import React from 'react';
import { Card } from 'reactstrap';
import { Skeleton } from '@mantine/core';

const SummaryCardSkeleton = () => {
	return (
		<Card className='card-height-100'>
			<div className='d-flex p-3'>
				<div className='flex-grow-1'>
					{/* Main value skeleton */}
					<Skeleton height={28} width='70%' mb={8} />
					{/* Title skeleton */}
					<Skeleton height={20} width='80%' mb={12} />
					{/* Difference text skeleton */}
					<div>
						<Skeleton height={12} width='60%' mb={4} />
						<Skeleton height={10} width='90%' />
					</div>
				</div>
				<div className='flex-shrink-0 align-self-center'>
					{/* Chart skeleton */}
					<Skeleton height={80} width={100} radius='sm' />
				</div>
			</div>
		</Card>
	);
};

export default SummaryCardSkeleton;
